import { SET_NET_STATUS } from '../constants/network';

const initState = {
  online: true,
  interface: true, // 接口状态
};

const network = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_NET_STATUS:
      return {
        ...state,
        online: action.online,
      };
    default:
      return state;
  }
};

export default network;
